import { getWithPrefix } from './index';

export const DEFAULT = 'default';

export const REPORT_CONTENT_ID = 'report-content';

export const MAX_CONTENT_WIDTH = 1300;

export const DATA_PATH = getWithPrefix('/data/PEFA_Public_Database_2022_Global_Report.xlsx');
export const REPORT_PATH = getWithPrefix('/data/Report.pdf');

export const CATEGORIES = {
  BACKGROUND: 'Background',
  REPORT: 'Report',
  PERFORMANCE: 'Performance',
  TOPIC_IN_FOCUS: 'Topic in Focus',
  TAKE_ACTION: 'Get Engaged',
  ABOUT: 'About',
  MONGOLIA: 'mongolia',
  COLOMBIA: 'colombia',
  APPENDIX: 'Appendix'
};

export const CHART_TYPES = {
  BAR: 'Bar',
  BAR_GROUPED: 'BarGrouped',
  BAR_STACKED: 'BarStacked',
  BAR_VERTICAL: 'BarVertical',
  BAR_VERTICAL_GROUPED: 'BarVerticalGrouped',
  BAR_VERTICAL_STACKED: 'BarVerticalStacked',
  BUBBLE: 'Bubble',
  BOX: 'Box',
  DONUT: 'Donut',
  MAP: 'Map',
  RADIAL: 'Radial',
  SLOPE: 'Slope',
  SPIDER: 'Spider',
  TABLE: 'Table',
  LINE: 'Line'
};

export const BLOCK_TYPES = {
  CARD_CAROUSEL: 'CardCarousel',
  CARD_GRID: 'CardGrid',
  CARD_NUMBER: 'CardNumber',
  CHART: 'Chart',
  CHART_CAROUSEL: 'ChartCarousel',
  CONTENT: 'Content',
  HERO: 'Hero',
  IMAGE: 'Image',
  TABLE: 'Table',
  VIDEO: 'Video',
  ABOUT_MODAL: 'About Modal',
  REFERENCES: 'References',
  TIMELINE: 'Timeline',
  VIDEO_CARD_CAROUSEL: 'VideoCardCarousel',
  VIDEO_CARD: 'VideoCard',
  BIG_NUMBER: 'BigNumber',
  ROW_CARD: 'RowCard',
  COLUMN_CARD: 'ColumnCard',
  UPDATED_CARD_GRID: 'UpdatedCardGrid'
};

export const BLOCK_ELEMENTS = {
  CARD: 'Card',
  CHART: 'Chart',
  CHARTS_AND_CARD: 'Charts + Card',
  NOTE: 'Note',
  WIDTH: 'Width (short or wide)',
  TITLE: 'Title',
};

export const ELEMENTS_TYPES = {
  PLAIN_TEXT: 'plain_text',
  MARKDOWN: 'markdown',
  CONNECTION: 'connection',
  CUSTOM_ELEMENT: 'custom_element',
  STATE: 'state',
  IMAGE: 'image',
};

export const WIDTH_TYPES = {
  SHORT: 'short',
  WIDE: 'wide',
};

export const ZINDEX = {
  SEARCH: 1,
  MAP_BACKGROUND: 1,
  CONTENT_EXPAND_FADE: 1,
  CONTENT_EXPAND_BUTTON: 2,
  CHART_CAROUSEL: 2,
  CONTENT_TOOLTIP: 10,
  TOOLTIP_BASIC: 11,
  CHART_CARD_TOGGLE_BUTTON: 49,
  CARD_LEFT: 50,
  MENU_MOBILE_BUTTON: 99,
  TABLE_OF_CONTENTS: 100,
  MODAL: 101,
  MODAL_CLOSE_BUTTON: 102,
  MODAL_CONTENT: 103,
};
